import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';
import PrimaryBoundarySelectPanelField from 'components/fields/PrimaryBoundarySelectPanelField';

import useSelectField from 'hooks/useSelectField';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

// Reads its value from the form but does not write it: selecting a boundary that belongs to
// another field has to be confirmed before the selection is committed, so `onChange` is handed
// up to the consumer rather than bound to the field.
const SelectPrimaryBoundaryField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        name,
        onChange,
        onRemove,
        ref,
        siteId,
        testId = TEST_ID
    } = props;

    const { PRIMARY_BOUNDARY, PRIMARY_BOUNDARY_PLACEHOLDER } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, value } = useSelectField<T>({
        control,
        name,
        ref
    });

    const panelOpenClass = isPanelOpen ? styles.panelOpen : '';

    return (
        <Wrapper
            className={`${styles.wrapper} ${panelOpenClass} ${className}`}
            ref={containerRef}
            testId={testId}>
            <WithField label={PRIMARY_BOUNDARY}>
                <EntitySelectPillButton
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={onRemove}
                    text={value?.label ?? PRIMARY_BOUNDARY_PLACEHOLDER}
                />
            </WithField>

            {isPanelOpen && (
                <PrimaryBoundarySelectPanelField
                    onChange={onChange}
                    onClose={handleClose}
                    siteId={siteId}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectPrimaryBoundaryField;
